<template>
    <modal
        name="comment-remove"
        height="auto"
        @before-open="beforeOpen"
    >
        <modal-skeleton>
            <template #heading>
                Remove Comment
            </template>
            <p>This will display anonymously and replace your comment with "comment removed by user"</p>
            <template #footer>
                <button
                    class="stripButton button -outline -square"
                    @click="handleClose"
                >
                    Cancel
                </button>
                <button
                    class="button -red -square"
                    @click="removeComment"
                >
                    Remove
                </button>
            </template>
        </modal-skeleton>
    </modal>
</template>

<script>
import ModalSkeleton from '../ModalSkeleton.vue';

export default {
    name: 'CommentRemoveModal',
    components: {
        ModalSkeleton,
    },
    data() {
        return {
            commentId: null,
            parentId: null,
        };
    },
    methods: {
        async removeComment() {
            if (this.parentId) {
                await this.$store.dispatch('comments/removeChildComment', {
                    commentId: this.commentId,
                    parentId: this.parentId,
                });
            } else {
                await this.$store.dispatch('comments/removeComment', this.commentId);
            }
            this.handleClose();
        },
        beforeOpen(event) {
            this.commentId = event.params.commentId;
            this.parentId = event.params.parentId || null;
        },
        handleClose() {
            this.$modal.hide('comment-remove');
        },
    },
};
</script>
